/* global fbq:true */
import DownloadApp from './DownloadApp'
import SignIn from './SignIn'
import {Link} from 'react-router'
import styles from './style.css'

export default class RegisterComplete extends React.Component {
  shouldComponentUpdate (nextProps, nextState) {
    return false
  }

  componentDidMount () {
    // Facebook Pixel
    fbq('init', '1661541900796850')
    fbq('track', 'CompleteRegistration')

    // Google Adwords Conversion Tracking
    /* <![CDATA[ */
    window.google_trackConversion({
      google_conversion_id: 950464113,
      google_conversion_label: 'tialCPGY7WQQ8dybxQM',
      google_remarketing_only: false
    })
    // ]]>
  }

  render () {
    return (
      <div className='container'>
        <div className='row' id='registerComplete'>
          <div className='col-md-2'>
            &nbsp;
          </div>
          <div className='col-md-8' id='all-set'>
            <center>
              <h2>
                All Set
              </h2>
              <br />
            </center>
            <div className={styles['bold']}>
              VERIFY YOUR ACCOUNT
            </div>
            <hr />
            <div className={`col-md-12 no-padding mb-40px`}>
              <p>
                Go to your email and click on the link we provide to verify your account.
              </p>
              <p>
                Not received an email? <Link to='/resend'>Resend email.</Link>
              </p>
            </div>
            <DownloadApp />
            <SignIn />
          </div>
          <div className='col-md-2'>
            &nbsp;
          </div>
          <div className='clear' />
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./app/pages/RegisterComplete/RegisterComplete.js